module.exports = __webpack_public_path__ + "static/img/i133.284e92dd.png";